<template>
  <div class="content">
    <div v-show="discountCouponList.total === 0">
      <div class="kongImg">
        <img
          alt=""
          :src="
            $common.getResourceUrl('pcweb/pcKongStatus/img_youhuiquankong.png')
          "
        />
        <p>查询不到优惠券呦，快去获取吧~</p>
      </div>
    </div>
    <div v-show="discountCouponList.total !== 0" class="youhuiBox">
      <div
        v-for="(item, index) in discountCouponList.data"
        :key="index"
        class="content-box"
        :class="{ opacity: item.status_text !== '待使用' }"
      >
        <div class="discount-top">
          <span class="juchi"></span>
          <div v-if="item.type === 0" class="maney">
            <span>￥</span>{{ item.discount * 1 }}
          </div>
          <div v-else class="maney">
            {{ item.discount * 10 }}
            <span>折</span>
          </div>
          <div class="discount-coupon">
            <p>{{ item.name }}</p>
            <p>{{ item.description }}</p>
          </div>
        </div>
        <div class="discount-bottom">
          <div>
            有效期:{{ `${item.create_time_show}-${item.invalid_time_show}` }}
          </div>
          <button v-if="item.status_text === '待使用'" @click="pushIndex">
            {{ item.status_text }}
          </button>
          <div v-if="item.status_text !== '待使用'">{{ item.status_text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDiscountCouponList } from '@/network/request'
export default {
  data() {
    return {
      pageInfo: {
        page: 1, // 页码
        limit: 10, // 每页显示多少条数据
      },
      discountCouponList: [], // 优惠券列表
    }
  },
  created() {
    this.getDiscountCouponList()
  },
  methods: {
    // 获取优惠券列表
    async getDiscountCouponList() {
      const res = await getDiscountCouponList(this.pageInfo)
      this.discountCouponList = res.data.result
      // console.log(this.discountCouponList)
    },
    pushIndex() {
      this.$router.push({
        path: '/xiaobai0',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
// 过期优惠券添加类名
.opacity {
  opacity: 0.5;
}
.kongImg {
  text-align: center;
  padding-top: 80px;
  img {
    margin: auto;
    width: 500px;
  }
  p {
    text-align: center;
    margin-top: 20px;
    color: #bbb;
    font-size: 16px;
  }
}
.content {
  padding: 20px 25px;
  .youhuiBox {
    display: flex;
    flex-wrap: wrap;
  }
  .content-box {
    width: 336px;
    height: 141px;
    background-color: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 20px;
    margin-right: 25px;
    .discount-top {
      position: relative;
      display: flex;
      align-items: center;
      height: 85px;
      background-color: pink;
      position: relative;
      background-image: linear-gradient(46deg, #e56e41 0%, #f09e3a 100%);
      .maney {
        color: white;
        font-size: 29px;
        padding: 0 15px;
        span {
          font-size: 16px;
        }
      }
      .discount-coupon {
        p:first-child {
          font-size: 18px;
          color: #ffffff;
        }
        p:last-child {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
    .juchi {
      position: absolute;
      bottom: -3px;
      display: inline-block;
      width: 100%;
      height: 4px;
      border-bottom: 6px dotted white;
    }
    .discount-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      div:first-child {
        font-size: 12px;
        letter-spacing: 1px;
        color: #828282;
        padding: 0 15px;
      }
      button {
        background-image: linear-gradient(46deg, #e56e41 0%, #f09e3a 100%);
        border-radius: 5px;
        text-align: center;
        padding: 6px 12px;
        font-size: 14px;
        color: #ffffff;
        margin-right: 15px;
        border: 0;
        cursor: pointer;
      }
      div:last-child {
        background-image: linear-gradient(46deg, #e56e41 0%, #f09e3a 100%);
        border-radius: 5px;
        text-align: center;
        padding: 6px 12px;
        font-size: 14px;
        color: #ffffff;
        margin-right: 15px;
        border: 0;
      }
    }
  }
}
</style>
